import { Box, styled } from "@mui/material";

export const Section = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '12px'
}))